import orderDetailsHtml from "../order/orderDetails.html";
import "./orderDetails.component.scss";

class OrderDetailsController {
    constructor($scope, $timeout, priceTypeService, translateService) {
        'ngInject';
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.priceType = priceTypeService;
        this.translate = translateService;
        this.ready = false;
        this.sumNet = 0;
        this.sumTax = 0;
        this.sumGros = 0;
    }

    $onInit() {

        if (typeof this.taxMultiplier === 'string') {
            this.taxMultiplier = parseFloat(this.taxMultiplier.replace(',', '.'));
        }

        for (const orderItem of this.orderItems) {
            this.sumNet += orderItem.price_net * orderItem.quantity;
            this.sumTax += (orderItem.price_net * this.taxMultiplier * orderItem.quantity) - (orderItem.price_net * orderItem.quantity);
            this.sumGros += orderItem.price_net * this.taxMultiplier * orderItem.quantity;
        }

        if (this.piggyBankValue > 0) {
            this.sumNet -= this.piggyBankValue;
            this.sumTax -= (this.piggyBankValue * this.taxMultiplier) - this.piggyBankValue;
            this.sumGros -= this.piggyBankValue * this.taxMultiplier;
        }
    }
}

let OrderDetailsComponent = {
    bindings: {
        shopId: '@',
        orderDate: '@',
        orderItems: '<',
        currency: '@',
        userLogged: '@',
        textAddToCart: '@',
        textSaveToMyProducts: '@',
        tooltipAddToCart: '@',
        textCantAddCreateProjectAgain: '@',
        piggyBankValue: '@',
        taxMultiplier: '@'
    },
    template: orderDetailsHtml,
    controller: OrderDetailsController
};

export default OrderDetailsComponent;
